import React from 'react';
import { Skeleton, Row } from 'antd';

const PixLimitSkeleton = () => {
  return (
    <>
      <Row
        align="middle"
        justify="space-between"
        className="pix-limit__body__item-key"
      >
        <div>
          <p className="pix-limit__body__text">
            <Skeleton.Button active />
          </p>
        </div>
        <Row align="middle">
          <Skeleton.Button active />
        </Row>
      </Row>
      <Row
        align="middle"
        justify="space-between"
        className="pix-limit__body__item-key"
      >
        <div>
          <p className="pix-limit__body__text">
            <Skeleton.Button active />
          </p>
        </div>
        <Row align="middle">
          <Skeleton.Button active />
        </Row>
      </Row>
    </>
  );
};

export default PixLimitSkeleton;
